export default {
  toPay: '/v3/recruit/equipment/pay',
  switch: '/v3/recruit/queue/city/switch'
}
